export default "__VITE_ASSET__3ea370bb__"